<template>
  <arco-popover
    key="avatar"
    v-model:popup-visible="popupVisible"
    :content-style="{ padding: '4px 8px' }"
    position="rb"
    trigger="click"
  >
    <div class="avatar_special">
      <Avatar
        :url="userStore.avatar"
        :name="userStore.userName"
        :avatar-options="{ size: 32 }"
        @click.stop="jumTaskInfo(null)"
      />

      <div v-show="!collapsed" class="user_box">
        <div class="user_info">
          <div class="user_name">
            {{ userStore.userName }}
          </div>
          <div class="dept_name">
            {{ userStore.deptName }}
          </div>
        </div>
        <IconCaretDown />
      </div>
    </div>
    <template #content>
      <div @click="popupVisible = false">
        <!-- <router-link to="/personal">
          <div class="menu_item">
            个人中心
          </div>
        </router-link> -->
        <router-link :to="{ name: 'ChangePassword', query: { redirect: $route.query.redirect || encodeURIComponent($route.fullPath) }}">
          <div class="menu_item">
            修改密码
          </div>
        </router-link>
        <div class="menu_item" v-if="showUserChange" @click="switchAccount">
          切换账号（测试专用）
        </div>
        <div class="menu_item" @click="logout">
          退出登录
        </div>
      </div>
    </template>
  </arco-popover>
</template>

<script>
import { mapStores } from 'pinia'
import { Message } from '@arco-design/web-vue'
import { loginNoPassword } from '@/api/system'
import { useUserStore } from '@/store/modules/user'
import { usePermissionStore } from '@/store/modules/permission'
import { getLoginOriginMark, setLoginOriginMark } from '@/tool/permission'

export default {
  name: 'AvatarSpecial',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      NODE_ENV: process.env.NODE_ENV,
      popupVisible: false,
      showUserChange: null
    }
  },
  computed: {
    ...mapStores(useUserStore)
  },
  created() {
    const key = window.sessionStorage.getItem('switch_employee')

    this.showUserChange = this.NODE_ENV === 'development'||key
  },
  methods: {
    logout() {
      usePermissionStore().logout()
      window.sessionStorage.removeItem('switch_employee')
    },
    switchAccount() {
      this.$PopSelector.open({
        title: '选择账号（测试专用）',
        type: 'user'
      }).submit(async({ user }) => {
        if (!user) {
          Message.error('请选择登录账号！')
          return false
        }

        const res = await loginNoPassword({ userId: user })

        const { tenantId } = await getLoginOriginMark()

        await setLoginOriginMark({
          accessToken: res.data.accessToken,
          refreshToken: res.data.refreshToken,
          tenantId: tenantId ? tenantId : 1
        })
        if(this.$route.path.includes('/member-employees/personnelDetails')) {
          const arr = window.location.href.split('/')
          const str = arr.slice(-1)[0]

          window.location.href = window.location.href.replace(`/employee-management/personnelDetails/${str}`, `/member-employees/personnelDetails/${user}`)
        }else location.reload()
      })
    },
    jumTaskInfo(id) {
      this.$router.push(`/member-employees/personnelDetails/${id||this.userStore.userId}`)
    }
  }
}
</script>

<style lang="less" scoped>
.avatar_special {
  position: absolute;
  bottom: 48px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  cursor: pointer;

  .user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 44px);
    overflow: hidden;
    .user_info {
      padding-left: 12px;
      width: calc(100% - 33px);
      .user_name, .dept_name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .dept_name {
        width: min-content;
        max-width: 100%;
        padding: 0 4px;
        color: rgba(78, 186, 88);
        background: rgba(78, 186, 88, 0.1);
      }
    }
    .arco-icon-caret-down { margin: 7px 12px 7px 7px; }
  }
}
.menu_item {
  min-width: 80px;
  height: 28px;
  line-height: 28px;
  padding: 0 12px;
  margin-bottom: 4px;
  text-align: center;
  cursor: pointer;
  &:hover { background-color: var(--color-fill-2); }
}
</style>
